import { HttpTypes } from '@/types';
import {
  AvailableDomainResponse,
  BaseRegisteredDomain,
  RegisteredDomain,
} from '@/types/http/domain';
import { AxiosInstance } from 'axios';

class Domain {
  private client: AxiosInstance;
  private routePath = '/sites/domain';

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async listAvailable(domain: string): Promise<HttpTypes.IResponse<AvailableDomainResponse[]>> {
    const result = await this.client.get('/sites/domain/check-availability', {
      params: {
        q: domain,
      },
    });
    return result.data;
  }

  async registerDomain(
    data: HttpTypes.RegisterDomainPayload
  ): Promise<HttpTypes.IResponse<AvailableDomainResponse>> {
    const result = await this.client.post('/sites/domain/register', data);
    return result.data;
  }

  async registeredDomainList(
    queryParams?: HttpTypes.FindParams
  ): Promise<HttpTypes.IResponse<RegisteredDomain[]>> {
    const res = await this.client.get('/sites/domain/registered-domain', {
      params: queryParams,
    });
    return res.data;
  }

  async updateDomain(
    data: HttpTypes.UpdateDomainPayload
  ): Promise<HttpTypes.IResponse<BaseRegisteredDomain>> {
    const result = await this.client.post('/sites/domain/update-domain', data);
    return result.data;
  }

  async activateDomain(
    data: HttpTypes.UpdateDomainPayload
  ): Promise<HttpTypes.IResponse<BaseRegisteredDomain>> {
    const result = await this.client.post('/sites/domain/activate-domain', data);
    return result.data;
  }

  async registerEmail(
    data: HttpTypes.UpdateDomainPayload
  ): Promise<HttpTypes.IResponse<BaseRegisteredDomain>> {
    const result = await this.client.post('/sites/domain/register-email', data);
    return result.data;
  }

  async verifyEmail(
    data: HttpTypes.VerifyEmailPayload
  ): Promise<HttpTypes.IResponse<BaseRegisteredDomain>> {
    const result = await this.client.post('/sites/domain/verify-email', data);
    return result.data;
  }

  async detailDomain(domain: string): Promise<HttpTypes.IResponse<BaseRegisteredDomain>> {
    const result = await this.client.get('/sites/domain/detail', {
      params: {
        q: domain,
      },
    });
    return result.data;
  }

  async listPointingDomain(): Promise<HttpTypes.DnsPointingListResponse> {
    const result = await this.client.get('/sites/domain/dns-setting');
    return result.data;
  }

  async delete(domain: string): Promise<Omit<HttpTypes.IResponse, 'data'>> {
    const result = await this.client.post(`${this.routePath}/delete`, {
      domain,
    });
    return result.data;
  }
}

export default Domain;
